import DatepickerHighlighter from './datepicker-highlighter-directive';

const MODULE_NAME = 'app.common.datepicker-highlighter';
const module = angular.module(MODULE_NAME, [])
    .directive(DatepickerHighlighter.DIRECTIVE_NAME, DatepickerHighlighter);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/datepicker-highlighter/datepicker-highlighter-module.js